import jwtDefaultConfig from '@/core/auth/jwt/jwtDefaultConfig'

export const getAccessToken = () => localStorage.getItem(jwtDefaultConfig.storageTokenKeyName)
export const getRefreshToken = () => localStorage.getItem(jwtDefaultConfig.storageRefreshTokenKeyName)
export const getAuthHeaderValue = () => `${jwtDefaultConfig.tokenType} ${getAccessToken()}`
export const getUser = () => localStorage.getItem(jwtDefaultConfig.storageUserDataKeyName)
export const setAccessToken = val => localStorage.setItem(jwtDefaultConfig.storageTokenKeyName, val)
export const setRefreshToken = val => localStorage.setItem(jwtDefaultConfig.storageRefreshTokenKeyName, val)
export const setUserData = val => localStorage.setItem(jwtDefaultConfig.storageUserDataKeyName, JSON.stringify(val))
export const removeAccessToken = () => localStorage.removeItem(jwtDefaultConfig.storageTokenKeyName)
export const removeRefreshToken = () => localStorage.removeItem(jwtDefaultConfig.storageRefreshTokenKeyName)
export const removeUserData = () => localStorage.removeItem(jwtDefaultConfig.storageUserDataKeyName)
export const isUserLoggedIn = () => !!(getUser() && getAccessToken())
export const getUserData = () => JSON.parse(getUser())
export const needRefreshToken = () => {
  const token = getAccessToken()
  const decodedToken = token ? decodeJwt(token) : token
  const exp = decodedToken ? decodedToken.exp : null
  if (!exp) {
    return false
  }
  const currentTime = Math.floor(Date.now() / 1000)
  const seconds = 30
  return exp - currentTime < seconds
}
export const decodeJwt = token => {
  const base64Url = token.split('.')[1]
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map(c => '%' + (`00${c.charCodeAt(0).toString(16)}`).slice(-2))
      .join('')
  )
  return JSON.parse(jsonPayload)
}
